import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { PfDocumentFileThumbComponent } from './pf-document-file-thumb.component';
import { PfDocumentImageGalleryComponent } from './pf-document-image-gallery.component';

@NgModule({
    imports: [
        CommonModule,
        IconModule,
        NzModalModule,
        NzSpinModule,
        NzUploadModule,
    ],
    declarations: [
        PfDocumentImageGalleryComponent,
        PfDocumentFileThumbComponent,
    ],
    exports: [PfDocumentImageGalleryComponent],
})
export class DocumentImageGalleryModule {}
